import { useTheme } from "styled-components";
import { ITheme } from "../../components/Theme/Theme.types.js";
import { useWindowSize } from "../useWindowSize/index.js";
import { Breakpoint } from "./useBreakpoint.types.js";

export const useBreakpoint = (): Breakpoint => {
    const { width } = useWindowSize();
    const theme = useTheme() as ITheme;
    const { breakpoints } = theme;

    return Object.entries(breakpoints).reduce<Breakpoint>((acc, [key, value]) => {
        if (width >= value) return key as Breakpoint;
        return acc;
    }, Breakpoint.XS);
};
